const TRACE_STORE_KEY = '__ASTROLABE_REQUEST_TRACE_STORE__'
const TRACE_LIMIT = 20
const TRACE_ENDPOINT = '/__openclaw/trace'

function getHost () {
  if (typeof window !== 'undefined') {
    return window
  }
  if (typeof global !== 'undefined') {
    return global
  }
  return {}
}

function getRequestTraceStore () {
  const host = getHost()
  if (!host[TRACE_STORE_KEY]) {
    host[TRACE_STORE_KEY] = {
      traces: [],
      lastTrace: null
    }
  }
  return host[TRACE_STORE_KEY]
}

function clonePayload (payload) {
  return payload === undefined ? undefined : JSON.parse(JSON.stringify(payload))
}

function shouldPublishTrace (host) {
  if (!host || !host.location || host.location.protocol !== 'http:') {
    return false
  }

  const hostname = String(host.location.hostname || '').toLowerCase()
  return hostname === 'localhost' || hostname === '127.0.0.1'
}

function publishTraceToDevServer (trace) {
  const host = getHost()
  if (!shouldPublishTrace(host)) {
    return
  }

  try {
    if (host.navigator && typeof host.navigator.sendBeacon === 'function' && typeof host.Blob === 'function') {
      const blob = new host.Blob([JSON.stringify(trace)], { type: 'application/json' })
      host.navigator.sendBeacon(TRACE_ENDPOINT, blob)
      return
    }

    if (typeof host.XMLHttpRequest === 'function') {
      const xhr = new host.XMLHttpRequest()
      xhr.open('POST', TRACE_ENDPOINT, true)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.send(JSON.stringify(trace))
    }
  } catch (error) {
    // trace 回传失败不能阻断正常业务请求
  }
}

function recordRequestTrace ({ name, url, payload }) {
  const store = getRequestTraceStore()
  const trace = {
    name,
    url,
    payload: clonePayload(payload),
    recordedAt: new Date().toISOString()
  }
  store.traces.push(trace)
  if (store.traces.length > TRACE_LIMIT) {
    store.traces.splice(0, store.traces.length - TRACE_LIMIT)
  }
  store.lastTrace = trace
  publishTraceToDevServer(trace)
  return trace
}

function clearRequestTraceStore () {
  const store = getRequestTraceStore()
  store.traces = []
  store.lastTrace = null
}

module.exports = {
  TRACE_STORE_KEY,
  TRACE_ENDPOINT,
  getRequestTraceStore,
  recordRequestTrace,
  clearRequestTraceStore
}
